import { render, staticRenderFns } from "./ApiDokumentation.vue?vue&type=template&id=6cb8b9c1&scoped=true"
import script from "./ApiDokumentation.vue?vue&type=script&lang=js"
export * from "./ApiDokumentation.vue?vue&type=script&lang=js"
import style0 from "./ApiDokumentation.vue?vue&type=style&index=0&id=6cb8b9c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb8b9c1",
  null
  
)

export default component.exports